exports = module.exports = require("../../node_modules/css-loader/dist/runtime/api.js")(false);
// Module
exports.push([module.id, ".App {\n  text-align: center;\n}\n\n.App-header {\n  min-height: 80vh;\n  display: flex;\n  flex-direction: column;\n  align-items: center;\n  justify-content: center;\n  font-size: 20px;\n  line-height: 1.4;\n}\n\n.App-link {\n  color: rgb(112, 76, 182);\n}\n", ""]);

